// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.has-variations[data-v-68280aee] {    \r\n  background-color: gainsboro !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
